import { select } from 'redux-saga/effects';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { PrescriptionValidationStepContainer } from '../../../../Configurator/steps/PrescriptionValidationStep/PrescriptionValidationStepContainer.js';
import { getIsExtraValidationStepEnabled, getPrescriptionType, getVerificationAllowed } from '../../selectors.js';

const prescriptionValidationStepBase = {
    onNext,
    stepStatus: (s)=>{
        /**
     * Page should only show when the customer chose to enter their prescription manually via our form ("NewPrescription").
     */ const isStepEnabled = getIsExtraValidationStepEnabled(s);
        const prescriptionType = getPrescriptionType(s);
        const isNewPrescription = CommerceToolsApi.isNewPrescription(prescriptionType);
        if (!isStepEnabled) {
            return 'hidden';
        }
        return isNewPrescription ? 'active' : 'skip';
    },
    view: PrescriptionValidationStepContainer
};
function* onNext() {
    const isVerificationAllowed = yield select(getVerificationAllowed);
    return !isVerificationAllowed;
}

export { prescriptionValidationStepBase };
//# sourceMappingURL=prescription-validation.js.map
